import { useViewport } from "@/responsive/viewport";

/**
 * Admin is read-only on phones (docs/design/web/WEB_ADMIN_DESIGN.md, decision 2): pages
 * still render, but every mutation control (add buttons, role selects, row
 * menus, save bars) is hidden. Each admin page reads this once.
 */
export function useAdminCanEdit(): boolean {
  return !useViewport().isMobile;
}
